import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faHouse,
  faMagnifyingGlass,
  faSackDollar,
  faUser,
  faComments,
  faBolt,
  faSuitcase,
  faUpload,
  faBell,
  faClipboard,
  faStar,
  faRocket,
  faChildReaching,
  faCrown,
  faHeart,
  faPlaneUp,
  faLaptop,
  faMartiniGlass,
  faDumbbell,
  faGamepad,
  faCircleInfo,
  faArrowLeft,
  faTimes,
  faEye,
  faEyeSlash,
  faExclamationCircle,
  faDownload,
  faCircle,
  faArrowRight,
  faTag,
  faCalendar,
  faAngleLeft,
  faAngleRight,
  faEllipsis,
  faHourglassStart,
  faFlagCheckered,
  faMedal,
  faPenToSquare,
  faArrowUp,
  faAward,
} from '@fortawesome/free-solid-svg-icons'
import {
  faEnvelope,
  faHeart as farHeart,
  faMessage,
  faFaceLaughWink,
  faPaperPlane,
  faFaceSurprise,
  faComment,
} from '@fortawesome/free-regular-svg-icons'
import {
  faInstagram,
  faLinkedin,
  faSquareFacebook,
  faTiktok,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faHouse,
  faMagnifyingGlass,
  faSackDollar,
  faUser,
  faComments,
  faBolt,
  faSuitcase,
  faUpload,
  faBell,
  faClipboard,
  faStar,
  faRocket,
  faChildReaching,
  faHeart,
  faPlaneUp,
  faLaptop,
  faMartiniGlass,
  faDumbbell,
  faGamepad,
  faCircleInfo,
  faArrowLeft,
  faTimes,
  faEye,
  faEyeSlash,
  faExclamationCircle,
  faDownload,
  faCircle,
  faArrowRight,
  faEllipsis,
  faHourglassStart,
  faFlagCheckered,
  faMedal,
  faPenToSquare,
  faArrowUp,
  faAward,
  faTag,
  faCalendar,
  faAngleLeft,
  faAngleRight,
  faCrown,
  faEnvelope,
  farHeart,
  faMessage,
  faFaceLaughWink,
  faPaperPlane,
  faFaceSurprise,
  faComment,
  faInstagram,
  faLinkedin,
  faSquareFacebook,
  faTiktok,
  faYoutube
)